import React from 'react';
import PropTypes from 'prop-types';

const TableCell = ({ children = null, width = {}, isSingleRow = false }) => (
    <div className="cell" style={width}>
        <div className={`checkbox-holder${isSingleRow ? ' single-row' : ''}`}>{children}</div>
    </div>
);

TableCell.propTypes = {
    isSingleRow: PropTypes.bool,
    width: PropTypes.shape({}),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default React.memo(TableCell);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/tableCell.js